/**
 * 旅ページ共通のフォーマッタ
 */

import { format } from 'date-fns'
import { ja } from 'date-fns/locale'

import type { Trip, TripVisit } from '@/api/types/trip'

/** 訪問スポット名（TripVisit は wifi を持たないので place のみで解決する） */
export const tripPlaceName = (visit: TripVisit, fallback = '不明な場所'): string =>
  visit.place?.display_name ?? fallback

/** 「2泊3日」「日帰り」 */
export const durationLabel = (trip: Pick<Trip, 'nights' | 'days'>): string =>
  trip.nights === 0 ? '日帰り' : `${trip.nights}泊${trip.days}日`

/** 「2025年5月3日(土) 〜 5月5日(月)」 */
export const dateRangeLabel = (trip: Pick<Trip, 'start_at' | 'end_at' | 'nights'>): string => {
  const start = new Date(trip.start_at)
  const end = new Date(trip.end_at)
  const startLabel = format(start, 'yyyy年M月d日(E)', { locale: ja })
  if (trip.nights === 0) return startLabel
  const endPattern = start.getFullYear() === end.getFullYear() ? 'M月d日(E)' : 'yyyy年M月d日(E)'
  return `${startLabel} 〜 ${format(end, endPattern, { locale: ja })}`
}

/** 距離を「12.3 km」「980 m」表記に */
export const distanceLabel = (km: number): string => (km >= 1 ? `${km.toFixed(1)} km` : `${Math.round(km * 1000)} m`)
